import * as React from 'react';
import styled, { css } from 'styled-components';
const StyledImage = styled.img `
  max-width: ${({ isResponsive }) => (isResponsive ? '100%' : 'none')};
  width: ${({ width }) => (width ? `${Number(width)}px` : '100%')};
  height: ${({ height }) => (height ? `${Number(height)}px` : 'auto')};
  border-radius: ${({ rounded }) => (rounded ? '50%' : '0')};
  ${({ align }) => align !== undefined
    ? css `
          width: auto;
        `
    : ''};
`;
const ImageAlignContainer = styled.div `
  ${({ align }) => align !== undefined
    ? css `
          text-align: ${align};
        `
    : ''};
`;
export class Image extends React.PureComponent {
    render() {
        const { align } = this.props;
        if (align) {
            return (React.createElement(ImageAlignContainer, Object.assign({}, this.props),
                React.createElement(StyledImage, Object.assign({}, this.props))));
        }
        return React.createElement(StyledImage, Object.assign({}, this.props));
    }
}
Image.defaultProps = {
    isResponsive: true,
    rounded: false,
};
//# sourceMappingURL=Image.js.map